var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "edit-info"
  }, [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("编辑个人信息")))])]), _c("el-form", {
    ref: "form",
    staticStyle: {
      width: "700px"
    },
    attrs: {
      model: _vm.form,
      "label-width": "100px",
      rules: _vm.rules
    }
  }, [_c("el-form-item", {
    attrs: {
      label: _vm.$t("管理员名称"),
      prop: "nickName",
      title: _vm.$t("管理员名称")
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.nickName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "nickName", $$v);
      },
      expression: "form.nickName"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      prop: "account",
      label: _vm.$t("账号"),
      title: _vm.$t("账号")
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.account,
      callback: function ($$v) {
        _vm.$set(_vm.form, "account", $$v);
      },
      expression: "form.account"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: _vm.$t("密码"),
      title: _vm.$t("密码"),
      prop: "password"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.password,
      callback: function ($$v) {
        _vm.$set(_vm.form, "password", $$v);
      },
      expression: "form.password"
    }
  })], 1), _c("el-form-item", {
    staticStyle: {
      position: "relative",
      "margin-bottom": "0px"
    },
    attrs: {
      label: _vm.$t("手机号"),
      title: _vm.$t("手机号"),
      prop: "mobile"
    }
  }, [_c("el-input", {
    attrs: {
      readonly: ""
    },
    model: {
      value: _vm.form.mobile,
      callback: function ($$v) {
        _vm.$set(_vm.form, "mobile", $$v);
      },
      expression: "form.mobile"
    }
  }, [_c("template", {
    slot: "prepend"
  }, [_c("el-select", {
    staticStyle: {
      width: "90px"
    },
    attrs: {
      placeholder: _vm.$t("请选择"),
      "option-label-prop": "value",
      disabled: ""
    },
    model: {
      value: _vm.form.globalRoaming,
      callback: function ($$v) {
        _vm.$set(_vm.form, "globalRoaming", $$v);
      },
      expression: "form.globalRoaming"
    }
  }, _vm._l(_vm.globalRoamingOptionData, function (item) {
    return _c("el-option", {
      key: item.label,
      attrs: {
        value: item.label
      }
    }, [_vm._v(_vm._s(item.label) + "  " + _vm._s(_vm.$t(item.value)))]);
  }), 1)], 1)], 2), _c("span", {
    staticClass: "edit-mobile",
    on: {
      click: _vm.openEditMobile
    }
  }, [_vm._v(_vm._s(_vm.$t("修改")))])], 1), _c("el-form-item", {
    staticStyle: {
      margin: "8px 0 0 0"
    }
  }, [_c("span", {
    staticStyle: {
      color: "#a0a0a0"
    }
  }, [_vm._v(_vm._s(_vm.$t("用于接收系统通知，未填写手机号可能无法正常接收")))])]), _c("el-form-item", {
    staticStyle: {
      "margin-bottom": "0px"
    },
    attrs: {
      label: _vm.$t("邮箱"),
      title: _vm.$t("邮箱"),
      prop: "email"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.email,
      callback: function ($$v) {
        _vm.$set(_vm.form, "email", $$v);
      },
      expression: "form.email"
    }
  })], 1), _c("el-form-item", {
    staticStyle: {
      margin: "8px 0 0 0"
    }
  }, [_c("span", {
    staticStyle: {
      color: "#a0a0a0"
    }
  }, [_vm._v(_vm._s(_vm.$t("用于接收系统通知，未填写邮箱可能无法正常接收")))])]), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t("保存")))])], 1)], 1), _c("mobile-form", {
    attrs: {
      visible: _vm.visible
    },
    on: {
      ok: _vm.saveMobileInfo,
      cancel: function ($event) {
        _vm.visible = false;
      }
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };